import { PromptTypes } from 'generated/graphql-types';
import { PromptTypeOption } from 'src/app/pages/prompt-register/models/prompt-type-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { promptTypeOptionActions } from './prompt-type-option.actions';

export const promptTypeOptionFeatureKey = 'promptTypeOptions';

export type PromptTypeOptionState = EagerSelectState<PromptTypeOption>;

const adapter = createEagerSelectAdapter<PromptTypeOptionState, PromptTypeOption>({
   featureKey: promptTypeOptionFeatureKey,
   selectId: (prompt: PromptTypeOption) => {
      return prompt.typeName ? prompt.typeName : '';
   },
});

export const promptTypeOptionSelectors = adapter.getSelectors(filterTypeNameOption);

const initialState = adapter.getInitialState();

export const promptTypeOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   promptTypeOptionActions.search,
   promptTypeOptionActions.searchReset,
   promptTypeOptionActions.loadFromApi,
   promptTypeOptionActions.loadFromApiSuccess,
   promptTypeOptionActions.loadFromApiFailure
);

export function filterTypeNameOption<T extends PromptTypeOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   const filteredOptions: T[] = Object.values(PromptTypes)
      .filter((typeName) => {
         if (searchText) {
            return typeName.toLowerCase().includes(searchText.toLowerCase());
         } else {
            return true;
         }
      })
      .map((typeName) => {
         return { typeName } as T;
      });

   return filteredOptions;
}
